/** Copy plain text to the clipboard, reporting whether it worked.
 *
 * navigator.clipboard exists only in a secure context. The deployed app behind https
 * qualifies, but hitting the host's port directly over plain http on the LAN does not —
 * and that's exactly when someone is reading recovery codes off a fresh install. Hence
 * the deprecated execCommand fallback, which is the only thing that works there. */
export async function copyText(text: string): Promise<boolean> {
  if (window.isSecureContext && navigator.clipboard) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      // Denied, or no user gesture — the fallback below may still succeed.
    }
  }
  return copyViaSelection(text);
}

function copyViaSelection(text: string): boolean {
  const textarea = document.createElement("textarea");
  textarea.value = text;
  textarea.setAttribute("readonly", "");
  // Off-screen rather than hidden: display:none / visibility:hidden elements can't be
  // selected, and execCommand("copy") copies the selection.
  textarea.style.position = "fixed";
  textarea.style.top = "-1000px";
  document.body.appendChild(textarea);
  textarea.select();
  try {
    return document.execCommand("copy");
  } catch {
    return false;
  } finally {
    textarea.remove();
  }
}
